// autogenerated
import {AthenaeumConstants, ServiceProvider} from "@reapptor-apps/reapptor-toolkit";

export default class SetFavoriteRequest {

    public id: string = "";

    public favorite: boolean = false;

    public readonly isSetFavoriteRequest: true = true;

    public static is(from?: object | null): boolean {
        // noinspection PointlessBooleanExpressionJS
        return (from != null) && ((from instanceof SetFavoriteRequest) || ((from as any).isSetFavoriteRequest === true));
    }

    public static as(from?: object | null): SetFavoriteRequest | null {
        return (SetFavoriteRequest.is(from)) ? from as SetFavoriteRequest : null;
    }

    public static isNew(from?: SetFavoriteRequest | string | null): boolean {
        return (
            (from == null) ||
            ((from === "") || (from === AthenaeumConstants.defaultGuid)) ||
            ((typeof from == "object") && (SetFavoriteRequest.isNew(from.id)))
        );
    }

    // #region Placeholder

    // Put your code here (function, properties, ect...)

    // #endregion
}

ServiceProvider.addType(SetFavoriteRequest, "SetFavoriteRequest");